export function MarksHistoryHeader() {
  return (
    <header className="px-4 pt-6">
      <div className="mx-auto w-full max-w-6xl">
        <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
          Marks Overview
        </h1>
        <p className="mt-2 text-sm font-medium text-gray-600">
          Read-only exam performance metrics across classes and sections.
        </p>
      </div>
    </header>
  );
}
